function callHandlers({ idx, len, handlersArr, args, callback }) {
  if (idx < len) {
    const continueProcessing = handlersArr[idx].apply(null, args);
    if (Promise.resolve(continueProcessing) === continueProcessing) {
      continueProcessing.then(() => {
        callHandlers({ idx: idx + 1, len, handlersArr, args, callback });
      }).catch(() => {
        callback();
      });
    } else if (continueProcessing) {
      callHandlers({ idx: idx + 1, len, handlersArr, args, callback });
    } else {
      callback();
    }
  } else {
    callback();
  }
}

export function onEnterHandler(handlersArr, extras) {
  return (nextState, replace, callback) => {
    if (!handlersArr || !Array.isArray(handlersArr) || !handlersArr.length) {
      return;
    }
    const onEnterHandlerArgs = [nextState, replace, /* currentPath= */this, extras];
    callHandlers({ idx: 0, len: handlersArr.length, handlersArr, args: onEnterHandlerArgs, callback });
  };
}

export function addOnEnterHandlers(routesArr, onEnterExtras) {
  const updatedRoutes = routesArr.map(route => {
    const r = { ...route };
    if (route.onEnter) {
      // eslint-disable-next-line max-len
      throw new Error(`[attachOnEnterHandlers] onEnter route attribute detected, please move your callback to onEnterHandlers array: ${r.onEnter}`);
    }
    if (route.onEnterHandlers && route.onEnterHandlers.length) {
      r.onEnter = onEnterHandler(route.onEnterHandlers, onEnterExtras);
    }
    if (route.indexRoute && route.indexRoute.onEnterHandlers && route.indexRoute.onEnterHandlers.length) {
      r.indexRoute = { ...route.indexRoute };
      r.indexRoute.onEnter = onEnterHandler(route.indexRoute.onEnterHandlers, onEnterExtras);
    }
    if (route.childRoutes) {
      r.childRoutes = addOnEnterHandlers(route.childRoutes, onEnterExtras);
    }
    return r;
  });

  return updatedRoutes;
}
